§<template>
    <ul :class="['pill-nav', theme]" style="display: inline-block;">
        <li v-for="item in items">
            <a :href="item[keys.url]" :class="{ 'active' : activeItemId === item[keys.id] }" @click="selected(item)">
                {{ item[keys.label]  }}
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            activeItemId: {
                type: [String,Number]
            },
            items: {
                type: Array
            },
            keys: {
                type: Object,
                default() {
                    return {
                        id: 'id',
                        url: 'url',
                        label: 'label',
                    }
                }
            },
            disableLinks: {
                type: Boolean,
                default: false,
            },
            theme: {
                type: String,
                default: ''
            }
        },
        methods: {
            selected(item) {
                this.$emit('change', item)

                if (this.disableLinks) {
                    return false
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pill-nav {
      padding: 0;
      margin-bottom:0 ;

        li {
          display: inline-block;
            cursor: pointer;
          a {
            padding: 3px 15px;
            margin: 0 3px;
            border-radius: 15px;
            font-weight: bold;
            font-size: .85rem;
            min-width: 80px;
            display: inline-block;
            text-align: center;
            background: #aaaaaa2e;
            color: #999999;

            &.active, &:hover {
                background: #2196f32e;
                color: #2196f3;
                text-decoration: none;
            }
          }
        }

        &.light {
            li a {
                background: #ffffff2e;
                color: white;

                &.active,
                &:hover {
                    background: #e5e5e5a3;
                }
            }
        }

        &.baremetrics {
            li a {
                background: #ccc;
                color: white;

                &.active,
                &:hover {
                    background: #6078ff;
                }
            }
        }
    }
</style>